import { useModuleStatuses } from '@common/features/properties';
import { useMemo } from 'react';
import { Item } from 'shared-types';
import { createModuleRecommendations } from '../BasketDrawer.helpers';
import { ModuleType } from '../BasketListing.types';

export const useModulesToRecommend = ({
  modules,
  items,
}: {
  modules: ModuleType[];
  items: Item[];
}) => {
  const {
    statuses: { isRoomsEnabled },
  } = useModuleStatuses();

  const recommendedModules = useMemo(() => {
    let updatedModules = modules;

    if (isRoomsEnabled) {
      updatedModules = updatedModules.concat('rooms');
    }

    // We don't ever want to show these types of modules
    const moduleFilter = updatedModules.filter(
      (module) => module !== 'products' && module !== 'vouchers' && module !== 'events'
    );

    return createModuleRecommendations(moduleFilter, items);
  }, [modules, items, isRoomsEnabled]);

  return recommendedModules;
};
